export const useItems = (t: any) => {
  return [t('delete_page.item_1'), t('delete_page.item_2'), t('delete_page.item_3'), t('delete_page.item_4')]
}
